<div
  class="free-text-content"
  [innerHTML]="field().settings?.label | safeHtml"
></div>
